<template>
    <!--页面加载动画-->
    <div class="img-show-box">
        <div class="items-wrap-list" v-if="selectData.elementValue.length>1">
            <span class="wrap-top">
            {{selectData.elementName}}
            </span>
            <div class="wrap-bottom">
            <van-image
                v-for="(pic, m) in selectData.elementValue"
                :key="'pic_' + m"
                :src="pic"
                @click="previewImgs(selectData.elementValue, m)"
            >
            </van-image>
            </div>
        </div>
        <div class="items-wrap" v-else>
            <span class="lables">
            {{selectData.elementName}}
            </span>
            <div class="from-right">
            <van-image
                v-for="(pic, m) in selectData.elementValue"
                :key="'pic_' + m"
                :src="pic"
                @click="previewImgs(selectData.elementValue, m)"
            >
            </van-image>
            </div>
        </div>
        <p v-if="selectData.elementDescribe" class="notes">{{selectData.elementDescribe}}</p>
    </div>
</template>

<script>
import { ImagePreview } from 'vant';
export default {
  data() {
    return {
      placeHolderPic: require("@static/images/width_placeholder.png"),
    };
  },
  props: ["selectData"],
  mounted() {

  },
  methods: {
    //图片预览
    previewImgs(list, index) {
      let arr = [];
      list.map((item) => {
        arr.push(item.url);
      });
      ImagePreview({
        images: arr, // 预览图片的那个数组
        showIndex: true,
        loop: false,
        startPosition: index, // 指明预览第几张图
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.img-show-box{
    border-bottom: 1px solid #eeeeee;
    .items-wrap{
        min-height: 60px;
        display: -webkit-box;
        display: flex;
        flex-wrap: nowrap;
        flex-direction: row;
        justify-content:space-between;
        align-items:center;
        padding: 15px 0;
        .from-right{
            width: 68%;
            text-align: right;
            /deep/.van-image{
                height: 150px;
                width: 150px;
                overflow:hidden;
                border-radius: 10px;
            }
            /deep/.van-image__img{
                width: 150px;
                height: auto;
                position: absolute;
                top: 50%;
                left:0;
                transform: translateY(-50%);
            }
        }
    }
    .items-wrap-list{
        padding: 15px 0;
        .wrap-top{
            width:100%;
            line-height: 44px;
            font-size: 30px;
            color: #000;
        }
        .wrap-bottom{
            margin-top: 15px;
            /deep/.van-image{
                height: 150px;
                width: 150px;
                overflow:hidden;
                background: #f8f8f8;
                border-radius: 10px;
                margin-right:20px;
            }
            /deep/.van-image__img{
                width: 150px;
                height: auto;
                position: absolute;
                top: 50%;
                left:0;
                transform: translateY(-50%);
            }
        }
    }
}
</style>
